import React from 'react';
import Menu from './Components/menu';
import Banner from './Components/banner';
import Features from './Components/features';
import Precos from './Components/precos';
import Testemunho from './Components/servicos';
import Quemsomos from './Components/quemsomos';
import Footer from './Components/footer';
import Contato from './Components/contato';
import Servicos from './Components/servicos';
import ComoFunciona from './Components/comofunciona';

function Site(){
    return <div>
      <Menu/>
      <Banner/> 
      <Servicos/>
      <ComoFunciona/>  
      <Precos/>   
      <Quemsomos/>
      <Contato/>
      <Footer/>
    </div>;
  }

export default Site;